/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Rating, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Testimonio = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{

                py: 3,
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Avatar src={item.img} sx={{width: 64, height: 64}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 18, fontWeight: 600}}> {item.nombre}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', mt: 1}}>
                <Rating defaultValue={5} sx={{fill: '#000'}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', mt: 2, px: 3,pb: 6}}>
                <Typography sx={{
                    fontSize: sCell ? 16 : 18,
                    fontWeight: 400,
                    color: '#000000',
                    textAlign: 'center'
                }}>
                    {item.testimonio}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Testimonio